import { useMemo } from "react";
import { useSelector } from "react-redux";

// state.events.puntosControl guarda el snapshot CRUDO de Firebase (no el
// valor ya deserializado) — ver events-actions.js/getPuntosControl. Ese
// snapshot sí mantiene su misma referencia entre dispatches que no lo
// tocan (el reducer solo lo reemplaza cuando llega un EVENT_POINTS_CONTROLS
// real), pero llamar snapshot.val() dentro de un useSelector genera un
// objeto nuevo en CADA llamada — eso rompe la comparación por referencia
// de useSelector y hace que el componente se re-renderice en cada dispatch
// de Redux de toda la app, no solo cuando puntosControl cambia de verdad.
// Durante un evento en vivo (lecturas de punto de control, resultados,
// participantes llegando seguido) eso se nota mucho.
//
// Este hook separa los dos pasos: useSelector sobre el snapshot (referencia
// estable) + useMemo para el .val(), que solo se vuelve a calcular cuando
// el snapshot realmente cambió.
export default function usePuntosControl() {
  const snapshot = useSelector((state) => state.events.puntosControl);
  return useMemo(() => (snapshot ? snapshot.val() : snapshot), [snapshot]);
}
